export class Position {
    constructor(x = 0, y = 0) {
        this.type = 'Position';
        // this.assert(x < 0 || y < 0);
        this._x = x;
        this._y = y;
    }
    clone() {
        return new Position(this._x, this._y);
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    set x(x) {
        // this.assert(x < 0);
        this._x = x;
    }
    set y(y) {
        // this.assert(y < 0);
        this._y = y;
    }
    applyVector(movement) {
        if (!movement) {
            return this;
        }
        if (Math.abs(movement.x) == Infinity || Math.abs(movement.y) == Infinity) {
            throw 'Infinity value is incorrect';
        }
        this.x += movement.x;
        this.y += movement.y;
        return this;
    }
    fromRelativeToAbsolute(canvas) {
        return new Position(this.x * canvas.width, this.y * canvas.height);
    }
    static hydrate(data) {
        let _a, _b;
        return new Position(
            (_a = data._x) !== null && _a !== void 0 ? _a : 0,
            (_b = data._y) !== null && _b !== void 0 ? _b : 0
        );
    }
}
